module.exports = __webpack_public_path__ + "img/interface-02.9696aa3a.jpg";